<template>
  <div
    class="answer"
    :class="{
      text: showText || !showImage,
      image: showImage,
      hovered: active,
      border0: selected
    }"
    @click="answeredQuestion(answer, index)"
    @mouseover="hover"
    @mouseout="endHover"
  >
    <AnswerText v-if="showText || !showImage" :answerText="getAnswerText" />
    <AnswerImage
      v-else-if="showImage"
      :answerImage="getAnswerImage"
      :answerText="getAnswerText"
    />
    <div class="answerChecked" v-if="selected">
      <font-awesome-icon :icon="checkedIcon" class="checkedIcon" />
    </div>
  </div>
</template>

<script>
import AnswerText from "./AnswerText.vue";
import AnswerImage from "./AnswerImage.vue";
import { mapState } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCheck as fasCheck } from "@fortawesome/free-solid-svg-icons/faCheck";

export default {
  name: "Answer",
  props: {
    answer: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      active: false,
      checkedIcon: fasCheck
    };
  },
  computed: {
    ...mapState(["siteSettings"]),
    getAnswerText() {
      return this.answer[0] || "";
    },
    getAnswerImage() {
      return this.answer[1] || "";
    },
    showImage() {
      return this.mode === "pic" && this.answer[1];
    },
    showText() {
      return this.mode === "text" && this.answer[0];
    }
  },
  components: {
    AnswerText,
    AnswerImage,
    FontAwesomeIcon
  },
  methods: {
    answeredQuestion(answer, answerIndex) {
      this.$emit("onAnsweredQuestion", { answer, answerIndex });
    },

    hover() {
      this.active = true;
    },
    endHover() {
      this.active = false;
    }
  }
};
</script>

<style lang="scss">
.answer {
  text-align: center;
  background: white;
  margin: 10px;
  padding: 10px;
  border: 2px solid white;
  cursor: pointer;
  box-shadow: 0 0 0 2px rgba(15, 78, 99, 0), 2px 4px 7px rgba(0, 0, 0, 0.11);
  display: flex;
  transition: all 0.32s;
  overflow: hidden;
  position: relative;
}
.answerChecked {
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 9999;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  font-size: 60px;
}
.answerChecked svg {
  position: absolute;
  right: 5px;
  bottom: 4px;
  margin: 0;
  width: 30px;
  cursor: pointer;
  animation: pop 0.3s linear 1;
  color: #08c;
}
@keyframes pop {
  50% {
    transform: scale(1.2);
  }
}
// .checked{
//   position:absolute;
//   width: 100%;
//   height: 100%;
//   background: black;
// }

.answer.hovered {
  border: 2px solid #eaeaea;
}

.answer.image {
  flex-direction: row;
  justify-content: space-between;
  width: 250px;
}

.answer.image.num-questions-4 {
  width: 180px;
}

.answer.image.num-questions-5 {
  width: 180px;
}

.answer.text {
  width: 100%;
  flex-direction: column;
  text-align: center;
}
.border0 {
  border: none !important;
}
</style>
